/*
 *  Module for working with the site as a Progressive Web App (PWA)
 */
rs.module("layouts/pwa",[],

    function () {

        // Initialize the module
        function initialize() {

            // If the the site is being viewed as a stand-alone PWA, indicate it on the page's HTML element
            // so it can be referenced by CSS
            if (isRunningStandAlonePWA()) {
                var htmlElement = document.documentElement;
                $(htmlElement).addClass('standalone-pwa');
            }
        }

        // Determine if the site is currently being viewed as a stand-alone PWA
        function isRunningStandAlonePWA() {

            // This will return true if the user is viewing the site in a stand-alone PWA app window.
            // This will return false if the user is viewing the site in a browser.
            return window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
        }

        // Use iosPWASplash with the icon and background color, which will generate appropriate
        // apple-touch-startup-image links in the page HEAD
        // https://github.com/avadhesh18/iosPWASplash
        function generateIosPwaSplash(iconPath, backgroundColor) {

            iosPWASplash(iconPath, backgroundColor);
        }

        var exports = {
            initialize: initialize,
            isRunningStandAlonePWA: isRunningStandAlonePWA,
            generateIosPwaSplash: generateIosPwaSplash
        };

        return exports;
    }
);